module.exports = __webpack_public_path__ + "media/images/plus-light-39d71db5a65c01bc931b221487e4bf80.svg";